import { AutoMap } from "@automapper/classes";

export class PrelevementEntity {

    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    OgiCode!: string;
    @AutoMap()
    SamplingJobId!: number;
    @AutoMap()
    ClientCode!: string;
    @AutoMap()
    Comment?: string;

    SamplingPointId?: number;
    ConsommableIds!: number[];
    FlaconIds!: number[];
}